import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { cn } from '../lib/utils'

interface Language {
  code: string
  name: string
  dir: 'ltr' | 'rtl'
}

const languages: Language[] = [
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
]

export function LanguageSwitcher() {
  const currentLang = localStorage.getItem('language') || 'en'
  const currentLanguage = languages.find(lang => lang.code === currentLang) || languages[0]

  const handleLanguageChange = (language: Language) => {
    localStorage.setItem('language', language.code)
    document.documentElement.lang = language.code
    document.documentElement.dir = language.dir
    
    // Reload the page to apply language changes
    window.location.reload()
  }

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center text-sm text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md hover:bg-gray-100">
        <svg className="w-5 h-5 mr-1 rtl:ml-1 rtl:mr-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
        <span>{currentLanguage.name}</span>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 rtl:right-auto rtl:left-0 z-10 mt-2 w-48 origin-top-right rtl:origin-top-left rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {languages.map((language) => (
            <Menu.Item key={language.code}>
              {({ active }) => (
                <button
                  onClick={() => handleLanguageChange(language)}
                  className={cn(
                    active ? 'bg-gray-100' : '',
                    language.code === currentLang ? 'font-semibold' : '',
                    'block w-full text-left rtl:text-right px-4 py-2 text-sm text-gray-700'
                  )}
                >
                  {language.name}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}